import AnnotationCC from "../../api/AnnotationCommunicationController";

export default class AnnotationType {
    id: number;
    name: string;
    description: string;
    annotation_tool: number;
    print_function: string;
    conflict_functions: string[];
    xml: string;
    instructions: string;

    constructor(obj: AnnotationType) {
        this.id = obj.id;
        this.name = obj.name;
        this.description = obj.description;
        this.annotation_tool = obj.annotation_tool;
        this.print_function = obj.print_function;
        this.conflict_functions = obj.conflict_functions;
        this.xml = obj.xml;
        this.instructions = obj.instructions;
    }

    update = async (data: {
        name: string;
        description: string;
        instructions: string;
        xml: string;
        print_function: string;
        conflict_functions: string[];
    }): Promise<boolean> => {
        if (!this.checkDifferences(data)) return false;

        await AnnotationCC.updateAnnotationInterface(this.annotation_tool, this.id, data);

        this.name = data.name;
        this.description = data.description;
        this.instructions = data.instructions;
        this.xml = data.xml;
        this.print_function = data.print_function;
        this.conflict_functions = data.conflict_functions;

        return true;
    };

    private checkDifferences = (data: {
        name: string;
        description: string;
        instructions: string;
        xml: string;
        print_function: string;
        conflict_functions: string[];
    }) => {
        if (this.name !== data.name) return true;
        if (this.description !== data.description) return true;
        if (this.instructions !== data.instructions) return true;
        if (this.xml !== data.xml) return true;
        if (this.print_function !== data.print_function) return true;

        for (const fn of data.conflict_functions) if (!this.conflict_functions.includes(fn)) return true;
        for (const fn of this.conflict_functions) if (!data.conflict_functions.includes(fn)) return true;

        return false;
    };
}
